import { createStyles } from '@mantine/core'

const useScrollAreaStyles = createStyles(
  (_theme, { height }: { height: number }) => ({
    scrollAreaWidthFix: {
      // paddingBottom: 0,
      // width: '100%',
      // [`> div:first-of-type`]: {
      //   display: 'block !important',
      // },
    },

    zeroBottomPadding: {
      paddingBottom: 0,
    },

    scrollAreaRoot: {
      width: '100%',
      height,
      overflow: 'hidden',
      paddingBottom: 0,
    },
    scrollbars: {
      zIndex: 3,
      backgroundColor: 'inherit',
    },
  }),
)

export default useScrollAreaStyles
